var map = {
	"./cat-1.jpg": 6806,
	"./cat-2.jpg": 6408,
	"./cat-3.jpg": 2421,
	"./cat-4.jpg": 7404,
	"./image1.jpeg": 40,
	"./image2.jpeg": 7168,
	"./image3.jpeg": 5849,
	"./image4.jpeg": 4506,
	"./image5.jpeg": 8215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2594;